import axios from "axios";

export default axios.create({
  baseURL: window._env_.REACT_APP_GAMIFICATION_ENGINE_ENDPOINT
});
